<template>
  <div class="columns is-multiline">
    <div class="column is-12">
      <div class="content">
        <h3>{{ i18n.documents[iso] }}</h3>
      </div>
    </div>
    <div class="column is-12 documents-table-wrapper">
      <b-table
        :data="templateDocuments || []"
        :sort-icon="sortIcon"
        :sort-icon-size="sortIconSize"
        :bordered="isBordered"
        :striped="false"
        :narrowed="isNarrowed"
        :hoverable="true"
        :loading="loadingReserves"
        :focusable="isFocusable"
        :mobile-cards="hasMobileCards"
      >
        <b-table-column
          field="Referencia"
          :label="i18n.document[iso]"
          v-slot="props"
          cell-class="is-vcentered"
          header-class="docs-th"
        >
          <b>{{ i18n[props.row.Referencia][iso] }}</b>
        </b-table-column>

        <b-table-column
          field="Nombre"
          :label="i18n.name[iso]"
          v-slot="props"
          cell-class="is-vcentered"
          header-class="docs-th"
        >
          <small v-if="!props.row.Nombre">{{ "" }}</small>
          <small v-else-if="props.row.Nombre && props.row.Nombre.length < 40">{{
            props.row.Nombre || ""
          }}</small>
          <b-tooltip type="is-light" position="is-bottom" multilined v-else>
            <b-tag type="is-light">
              <small
                >{{
                  props.row.Nombre && props.row.Nombre.substring(0, 40)
                }}...</small
              >
            </b-tag>
            <template v-slot:content>
              <b>{{ parseLongText(props.row.Nombre) }}</b>
            </template>
          </b-tooltip>
        </b-table-column>

        <b-table-column
          field="FechaCreacion"
          :label="i18n.dateUpload[iso]"
          centered
          v-slot="props"
          cell-class="is-vcentered"
          header-class="docs-th"
        >
          <b-tag type="is-light" v-if="props.row.FechaCreacion">{{
            parseDate(props.row.FechaCreacion)
          }}</b-tag>
          <span v-else>—</span>
        </b-table-column>

        <b-table-column
          field="CreadoPor"
          :label="i18n.uploadedBy[iso]"
          centered
          v-slot="props"
          cell-class="is-vcentered"
          header-class="docs-th"
        >
          {{ props.row.CreadoPor || "" }}
        </b-table-column>

        <b-table-column
          field="Id"
          :label="i18n.status[iso]"
          centered
          v-slot="props"
          cell-class="is-vcentered"
          header-class="docs-th"
        >
          <b-tag type="is-success is-light" v-if="props.row.Id">{{
            i18n.uploadedDocument[iso]
          }}</b-tag>
          <b-tag type="is-danger is-light" v-else>{{
            i18n.pendingUpload[iso]
          }}</b-tag>
        </b-table-column>

        <b-table-column
          :label="i18n.dateSent[iso]"
          centered
          v-slot="props"
          cell-class="is-vcentered"
          header-class="docs-th"
        >
          <b-tag type="is-info is-light" v-if="getLastFirma(props.row.Referencia, 'FechaEnvio')">{{
            parseDate(getLastFirma(props.row.Referencia, 'FechaEnvio'))
          }}</b-tag>
          <span v-else>—</span>
        </b-table-column>

        <b-table-column
          :label="i18n.dateSigned[iso]"
          centered
          v-slot="props"
          cell-class="is-vcentered"
          header-class="docs-th"
        >
          <b-tag type="is-success is-light" v-if="getLastFirma(props.row.Referencia, 'FechaFirma')">{{
            parseDate(getLastFirma(props.row.Referencia, 'FechaFirma'))
          }}</b-tag>
          <span v-else>—</span>
        </b-table-column>

        <b-table-column label="Actions" v-slot="props" centered cell-class="is-vcentered" header-class="docs-th">
          <div class="actions-group">
            <b-tooltip type="is-primary is-light">
              <a
                class="action-btn"
                @click="downloadPdfOwners(props.row.Referencia)"
              >
                <b-icon
                  pack="fas"
                  icon="spinner"
                  custom-class="fa-spin"
                  type="is-primary is-light"
                  v-if="loadingGenerateDocument === props.row.Referencia"
                >
                </b-icon>
                <b-icon
                  pack="fas"
                  icon="file-pdf"
                  size="is-small"
                  type="is-primary is-light"
                  v-else
                >
                </b-icon>
              </a>
              <template v-slot:content>
                <b>{{ i18n.generateDocument[iso] }}</b></template
              >
            </b-tooltip>
            <b-tooltip type="is-success is-light" v-if="!props.row.Id">
              <b-icon
                pack="fas"
                icon="spinner"
                custom-class="fa-spin"
                type="is-success is-light"
                v-if="loadingUploadDocument === props.row.Referencia"
              >
              </b-icon>
              <b-upload
                v-model="file"
                expanded
                @input="uploadFile(props.row.Referencia)"
                accept="application/pdf"
                v-else
              >
                <a class="action-btn">
                  <b-icon
                    pack="fas"
                    icon="file-upload"
                    size="is-small"
                    type="is-success is-light"
                  ></b-icon>
                </a>
              </b-upload>
              <template v-slot:content>
                <b>{{ i18n.uploadDocument[iso] }}</b></template
              >
            </b-tooltip>
            <b-tooltip type="is-info is-light" v-if="props.row.Id">
              <b-icon
                pack="fas"
                icon="spinner"
                custom-class="fa-spin"
                type="is-info is-light"
                v-if="loadingDownloadDocument === props.row.Referencia"
              >
              </b-icon>
              <a
                class="action-btn"
                @click="
                  downloadFile(props.row.Referencia, props.row.Id, props.row.Nombre)
                "
                v-else
              >
                <b-icon
                  pack="fas"
                  icon="file-download"
                  size="is-small"
                  type="is-info is-light"
                >
                </b-icon>
              </a>
              <template v-slot:content>
                <b>{{ i18n.downloadDocument[iso] }}</b></template
              >
            </b-tooltip>
            <b-tooltip type="is-danger is-light" v-if="props.row.Id">
              <b-icon
                pack="fas"
                icon="spinner"
                custom-class="fa-spin"
                type="is-danger is-light"
                v-if="loadingRemoveDocument === props.row.Referencia"
              >
              </b-icon>
              <a
                class="action-btn"
                @click="removeDocument(props.row.Referencia, props.row.Id)"
                v-else
              >
                <b-icon
                  pack="fas"
                  icon="trash"
                  size="is-small"
                  type="is-danger is-light"
                >
                </b-icon>
              </a>
              <template v-slot:content>
                <b>{{ i18n.removeDocument[iso] }}</b></template
              >
            </b-tooltip>
            <b-tooltip type="is-info is-light" v-if="canSendToSign(props.row.Referencia)">
              <b-icon
                pack="fas"
                icon="spinner"
                custom-class="fa-spin"
                type="is-info is-light"
                v-if="loadingSendToSign === props.row.Referencia"
              >
              </b-icon>
              <a
                class="action-btn"
                @click="sendDocumentToSign(props.row.Referencia)"
                v-else
              >
                <b-icon
                  pack="fas"
                  icon="file-signature"
                  size="is-small"
                  type="is-info is-light"
                >
                </b-icon>
              </a>
              <template v-slot:content>
                <b>{{ i18n.sendToSign[iso] }}</b></template
              >
            </b-tooltip>
          </div>
        </b-table-column>
      </b-table>
    </div>
  </div>

  <!-- <div style="display: flex">
    <div>
      <p class="title is-4">{{ i18n.documents[iso] }}</p>
      <hr />
      <div class="buttons-column">
        <b-button type="is-primary" class="is-fullwidth mb-3"
          >Licencia de Usuario</b-button
        >
        <b-button type="is-primary" class="is-fullwidth mb-3"
          >Contrato</b-button
        >
        <b-button type="is-primary" class="is-fullwidth mb-3"
          >Friends and Family</b-button
        >
        <b-button type="is-primary" class="is-fullwidth mb-3">ADP</b-button>
        <b-button type="is-primary" class="is-fullwidth mb-3"
          >Compra de Villa</b-button
        >
        <b-button type="is-primary" class="is-fullwidth mb-3"
          >Cash Out</b-button
        >
        <b-button type="is-primary" class="is-fullwidth mb-3">Pagare</b-button>
        <b-button type="is-primary" class="is-fullwidth mb-3">CDP</b-button>
      </div>
    </div>
    <div class="vertical-line"></div>
    <div style="width: 100%">
      <p class="title is-4">{{ i18n.listDocuments[iso] }}</p>
      <hr />
      <div class="button-content">
        <b-upload v-model="file" @input="uploadFile">
          <a class="button is-primary">
            <b-icon icon="upload"></b-icon>
          </a>
        </b-upload>
      </div>
      <div v-if="showFiles.length === 0" class="no-files">
        <p class="title">Sin archivos</p>
      </div>
      <div v-else>
        <b-table :data="showFiles">
          <b-table-column :label="i18n.fileName[iso]" v-slot="props" centered>
            {{ props.row.Nombre }}
          </b-table-column>
          <b-table-column :label="i18n.fileformat[iso]" v-slot="props" centered>
            {{ props.row.Formato }}
          </b-table-column>
          <b-table-column :label="i18n.user[iso]" v-slot="props" centered>
            {{ props.row.CreadoPor }}
          </b-table-column>
          <b-table-column :label="i18n.dateUpload[iso]" v-slot="props" centered>
            {{ parseDate(props.row.FechaCreacion) }}
          </b-table-column>
          <b-table-column :label="i18n.actions[iso]" v-slot="props" centered>
            <b-button
              type="is-danger"
              class="mr-2"
              @click="deleteFile(props.row.Id)"
            >
              <b-icon icon="delete"></b-icon>
            </b-button>
            <b-button
              type="is-info"
              @click="downloadFile(props.row.Id, props.row.Nombre)"
            >
              <i class="fas fa-download"></i>
            </b-button>
          </b-table-column>
        </b-table>
      </div>
    </div>
  </div> -->
</template>

<script>
import i18n from "../../utils/i18n";
import moment from "moment";
import axios from "axios";
const API_URL = process.env.VUE_APP_API_URL;

export default {
  name: "ContractMember",
  props: {
    contract: {
      type: Object,
      required: true,
    },
    templateDocuments: {
      type: Array,
      required: true,
    },
    member: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    firmasPlantillas: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      /**
       * Table
       */
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      isBordered: false,
      isStriped: true,
      isNarrowed: true,
      isHoverable: true,
      isFocusable: false,
      hasMobileCards: true,
      loadingReserves: false,
      loadingGenerateDocument: null,
      loadingUploadDocument: null,
      loadingRemoveDocument: null,
      loadingDownloadDocument: null,
      loadingSendToSign: null,

      /**
       * Table
       */
      i18n,
      user: null,
      iso: null,
      file: null,
      showFiles: [],
      data: null,
      processedFiles: [],
      selectedFiles: [],
    };
  },
  async created() {
    this.iso = localStorage.getItem("iso");
    this.user = localStorage.getItem("user");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
    });

    // this.templateDocuments = this.contract?.ClubId?.Plantillas || [];
  },
  async mounted() {
    await this.getFiles();
  },
  methods: {
    canSendToSign(referencia) {
      if (!this.firmasPlantillas) return false;
      return !!this.firmasPlantillas[referencia];
    },
    getLastFirma(referencia, field) {
      const firmas = this.contract?.Firmas;
      if (!firmas || !Array.isArray(firmas)) return null;
      const matching = firmas.filter((f) => f.Documento === referencia);
      if (matching.length === 0) return null;
      const last = matching[matching.length - 1];
      return last[field] || null;
    },
    async sendDocumentToSign(referencia) {
      this.$buefy.dialog.confirm({
        message: this.i18n.sendToSign__confirm[this.iso],
        onConfirm: async () => {
          try {
            this.loadingSendToSign = referencia;

            const recipientName = `${this.member?.Nombre || ''} ${this.member?.ApellidoPaterno || ''}`.trim();
            const recipientEmail = this.member?.Email || '';

            await axios.post(`${API_URL}/signature/send-document-by-email`, {
              recipientEmail,
              recipientName,
              documentType: referencia,
              contractId: this.contract.Id,
            });

            this.$buefy.toast.open({
              message: this.i18n.sendToSign__success[this.iso],
              type: 'is-success',
            });

            this.loadingSendToSign = null;
          } catch (err) {
            console.log(err);
            this.loadingSendToSign = null;
            this.$buefy.toast.open({
              message: this.i18n.sendToSign__error[this.iso],
              type: 'is-danger',
            });
          }
        },
      });
    },
    async uploadFile(ref) {
      try {
        this.loadingUploadDocument = ref;

        const formData = new FormData();
        formData.append("pdf", this.file);

        const headers = { "Content-Type": "multipart/form-data" };

        await axios.post(
          `${API_URL}/file-contract/${this.contract.Id}/${ref}?user=${this.user}`,
          formData,
          headers
        );
        this.file = null;

        this.$buefy.toast.open({
          message: this.i18n.documentUploadSuccessfully[this.iso],
          type: "is-success",
        });

        this.loadingUploadDocument = null;
        await this.$emit("refreshProfile");
      } catch (err) {
        console.log(err);
        this.loadingUploadDocument = null;
        this.$buefy.toast.open({
          message: this.i18n.documentUploadError[this.iso],
          type: "is-danger",
        });
      }
    },
    async downloadFile(ref, fileId, filename) {
      try {
        this.loadingDownloadDocument = ref;

        const { data } = await axios.get(`${API_URL}/file-contract/${fileId}`, {
          responseType: "blob",
        });
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        // link.remove();
        this.loadingDownloadDocument = null;
      } catch (err) {
        console.log(err);
        this.$buefy.toast.open({
          message: "Error",
          type: "is-danger",
        });
      }
    },
    async deleteFile(fileId) {
      try {
        await axios.delete(`${API_URL}/file-contract/${fileId}`);

        this.$buefy.toast.open({
          message: "Se Eliminó el Archivo",
          type: "is-success",
        });
        await this.getFiles();
      } catch (err) {
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al Eliminar Archivo",
          type: "is-danger",
        });
      }
    },
    async getFiles() {
      try {
        const { data } = await axios.get(
          `${API_URL}/file-contract/list/${this.contract.Id}`
        );
        this.showFiles = data.files;
        console.log(data.files);
      } catch (err) {
        console.log(err);
      }
    },
    parseDate(value) {
      moment.locale(this.iso);
      return value ? moment(value).utc().format("LL") : "--";
    },
    async downloadPdfOwners(type) {
      try {
        //Loadings
        this.loadingGenerateDocument = type;

        const { data } = await axios.get(
          `${API_URL}/catcher/pdf-download/owners?type=${type}&contractId=${this.contract.Id}`
        );

        const url = window.URL.createObjectURL(
          new Blob([new Uint8Array(data.pdf.data).buffer])
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Document_${Date.now()}.pdf`);
        document.body.appendChild(link);
        link.click();

        //Loadings
        this.loadingGenerateDocument = null;

        this.$buefy.dialog.alert({
          message: this.i18n.documentGeneratedSuccessfully[this.iso],
          type: "is-success",
          hasIcon: true,
          icon: "check-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
      } catch (err) {
        console.log(err);
        this.templLoading = null;
        this.$buefy.dialog.alert({
          message: this.i18n.documentGeneratedError[this.iso],
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
      }
    },
    async removeDocument(ref, fileId) {
      try {
        this.loadingRemoveDocument = ref;

        await axios.delete(`${API_URL}/file-contract/${fileId}`);

        this.$buefy.toast.open({
          message: this.i18n.documentRemovedSuccessfully[this.iso],
          type: "is-success",
        });

        this.loadingRemoveDocument = null;
        await this.$emit("refreshProfile");
      } catch (err) {
        console.log(err);
        this.loadingRemoveDocument = null;
        this.$buefy.toast.open({
          message: this.i18n.documentRemovedError[this.iso],
          type: "is-danger",
        });
      }
    },
    parseLongText(text) {
      if (!text) return "";
      const textSplit = text.split("");
      let acum = 0;
      let newText = [];
      for (let i in textSplit) {
        if (acum < 24) {
          newText.push(textSplit[i]);
          acum += 1;
        } else {
          newText.push(" ");
          newText.push(textSplit[i]);
          acum = 0;
        }
      }
      return newText.join("");
    },
  },
};
</script>

<style scoped>
.documents-table-wrapper {
  width: 100%;
}

.documents-table-wrapper >>> .b-table .table-wrapper {
  overflow-x: hidden;
}

.documents-table-wrapper >>> .table {
  table-layout: fixed;
  width: 100%;
}

.documents-table-wrapper >>> .table td,
.documents-table-wrapper >>> .table th {
  vertical-align: middle;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  text-overflow: ellipsis;
  padding: 0.5em 0.4em;
  font-size: 0.9em;
}

.actions-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}

.action-btn {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.15s ease;
}

.action-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.custom-button {
  flex: 1;
  margin-right: 10px;
  width: 300px;
  font-size: 1rem;
}
.button-row {
  display: flex;
  margin-right: 10px;
}
.button-content {
  display: flex;
}
.culumn-content {
  justify-content: center;
}
.vertical-line {
  border-left: 1px solid lightgray;
  height: 520px;
  margin: 0 20px;
}
.no-files {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  color: gray;
}
</style>
